import { Button, Tooltip } from "@suraasa/placebo-ui"
import { useMediaQuery } from "@suraasa/placebo-ui-legacy"
import { AssessmentQuestion } from "api/resources/assessments/types"
import clsx from "clsx"
import SlidingSheet from "components/SlidingSheet"
import { ArrowLeft, ArrowRight, NavArrowDown, NavArrowUp } from "iconoir-react"
import { useEffect, useRef, useState } from "react"
import { breakpoints } from "utils/createBreakpoints"

import QuestionPanel from "../QuestionPanel"

// import { GA } from "shared/utils/googleAnalytics"

const AssessmentFooter = ({
  onNext,
  onPrevious,
  onQuestionChange,
  questions,
  currentQuestion,
}: {
  onNext: () => void
  onPrevious: () => void
  onQuestionChange: (questionNumber: number) => void
  questions: AssessmentQuestion[]
  currentQuestion: AssessmentQuestion
}) => {
  const [questionsTrayOpen, toggleQuestionsTrayOpen] = useState(false)

  const isMdDown = useMediaQuery(breakpoints.down("md"))
  const isXsDown = useMediaQuery(breakpoints.down("xs"))

  const ref = useRef<HTMLDivElement>(null)

  /**
   * This useEffect is responsible for closing the questions panel if user clicks outside it
   */
  useEffect(() => {
    const container = ref.current
    const listener = function (event: any) {
      if (event && container)
        if (container.contains(event.target)) {
          // Clicked inside
        } else {
          // Clicked outside
          if (questionsTrayOpen) {
            toggleQuestionsTrayOpen(false)
          }
        }
    }
    if (container) {
      document.body.addEventListener("click", listener)
    }

    return () => {
      document.body.removeEventListener("click", listener)
    }
  }, [questionsTrayOpen])

  const isFirstQuestion = currentQuestion.questionNumber === 1
  const isLastQuestion = currentQuestion.questionNumber === questions.length

  if (isMdDown) {
    return (
      <>
        <SlidingSheet
          open={questionsTrayOpen}
          onClose={() => toggleQuestionsTrayOpen(false)}
          className="max-w-[900px]"
        >
          <QuestionPanel
            onClose={() => toggleQuestionsTrayOpen(false)}
            onQuestionChange={questionNumber => {
              toggleQuestionsTrayOpen(false)
              onQuestionChange(questionNumber)
            }}
            questions={questions}
            currentQuestion={currentQuestion}
          />
        </SlidingSheet>
        <div
          ref={ref}
          className={clsx(
            "bg-onSurface-800 px-2 py-1 sm:flex sm:items-center sm:justify-between",
            isMdDown ? "rounded-none" : "rounded-b-lg"
          )}
        >
          {!isXsDown && (
            <Button
              // {...(questionsTrayOpen
              //   ? GA.trackElement("ito-assessment-questions-tray-open-btn", {
              //       feature: "ito",
              //       purpose: "attempt_assessment",
              //     })
              //   : {})}
              variant="text"
              className="text-common-white-500"
              color="null"
              onClick={() => toggleQuestionsTrayOpen(prev => !prev)}
              startAdornment={
                questionsTrayOpen ? <NavArrowDown /> : <NavArrowUp />
              }
            >
              <div className="grid grid-flow-col items-center gap-0.5">
                Questions Tray
              </div>
            </Button>
          )}

          <div className="grid grid-flow-col items-center justify-between sm:justify-end sm:gap-1">
            <div>
              <Tooltip
                content="This is the first question"
                enabled={isFirstQuestion}
              >
                <div>
                  <Button
                    size="sm"
                    startAdornment={!isXsDown && <ArrowLeft />}
                    onClick={onPrevious}
                    disabled={isFirstQuestion}
                  >
                    Previous
                  </Button>
                </div>
              </Tooltip>
            </div>
            {isXsDown && (
              <Button
                //   {...(questionsTrayOpen
                //     ? {}
                //     : GA.trackElement("ito-assessment-questions-tray-open-btn", {
                //         feature: "ito",
                //         purpose: "attempt_assessment",
                //       }))}
                variant="text"
                className="text-common-white-500"
                color="null"
                onClick={() => toggleQuestionsTrayOpen(prev => !prev)}
              >
                <div className="grid grid-flow-col items-center gap-0.5">
                  {questionsTrayOpen ? <NavArrowDown /> : <NavArrowUp />}
                  Questions
                </div>
              </Button>
            )}
            <div>
              <Tooltip
                content="This is the last question"
                enabled={isLastQuestion}
              >
                <div>
                  <Button
                    size="sm"
                    endAdornment={!isXsDown && <ArrowRight />}
                    onClick={onNext}
                    disabled={isLastQuestion}
                  >
                    Next
                  </Button>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <div
      className={clsx(
        "grid grid-flow-col items-center justify-end gap-1 rounded-b-lg bg-onSurface-800 px-2 py-1 lg:mb-0.5",
        isMdDown ? "rounded-none" : "rounded-b-lg"
      )}
    >
      <Tooltip content="This is the first question" enabled={isFirstQuestion}>
        <div>
          <Button
            size="sm"
            startAdornment={!isXsDown && <ArrowLeft />}
            onClick={onPrevious}
            disabled={isFirstQuestion}
          >
            Previous
          </Button>
        </div>
      </Tooltip>
      <Tooltip content="This is the last question" enabled={isLastQuestion}>
        <div>
          <Button
            size="sm"
            endAdornment={!isXsDown && <ArrowRight />}
            onClick={onNext}
            disabled={isLastQuestion}
          >
            Next
          </Button>
        </div>
      </Tooltip>
    </div>
  )
}

export default AssessmentFooter
